const DASHBOARD_BASE_URL =
  (import.meta.env.VITE_DASHBOARD_URL as string) ??
  "https://dashboard.rockethealth.app";

export const WOMENS_HEALTH_CONSULT_STANDARD_ID =
  "d00001d1-0722-4cae-9dbe-78038d462eb8";
export const WOMENS_HEALTH_FOLLOWUP_STANDARD_ID =
  "c9fc513e-1413-4e35-8465-4aaa0086538c";

export const WOMENS_HEALTH_BUNDLE_IDS = [
  WOMENS_HEALTH_CONSULT_STANDARD_ID,
  WOMENS_HEALTH_FOLLOWUP_STANDARD_ID,
];

const buildLink = (path: string, usageId: string, includeUsageId = true) =>
  `${DASHBOARD_BASE_URL}${path}${includeUsageId ? `?usage_id=${usageId}` : ""}`;

export const isWomensHealthBundle = (standardId: string) =>
  WOMENS_HEALTH_BUNDLE_IDS.includes(standardId);

/**
 * Follow-up links for copying to clipboard.
 * Free follow-up includes usage_id (consumes from existing bundle).
 * Paid follow-up omits usage_id (user needs to purchase a new pack).
 */
export function getWomensHealthFollowUpLinks({ usage_id }: { usage_id: string }) {
  return {
    free: buildLink(
      "/schedule/gynaecology-consultation-free-follow-up",
      usage_id,
    ),
    paid: buildLink(
      "/schedule/gynaecology-consultation-paid-follow-up",
      usage_id,
      false,
    ),
  };
}
